import { microTask as a } from './micro-task.js';
function o() {
  let s = [],
    r = {
      addEventListener(e, t, n, i) {
        return e.addEventListener(t, n, i), r.add(() => e.removeEventListener(t, n, i));
      },
      requestAnimationFrame() {
        let t = requestAnimationFrame(...arguments);
        return r.add(() => cancelAnimationFrame(t));
      },
      nextFrame() {
        for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
          e[_key] = arguments[_key];
        }
        return r.requestAnimationFrame(() => r.requestAnimationFrame(...e));
      },
      setTimeout() {
        let t = setTimeout(...arguments);
        return r.add(() => clearTimeout(t));
      },
      microTask() {
        for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          e[_key2] = arguments[_key2];
        }
        let t = {
          current: !0
        };
        return a(() => {
          t.current && e[0]();
        }), r.add(() => {
          t.current = !1;
        });
      },
      style(e, t, n) {
        let i = e.style.getPropertyValue(t);
        return Object.assign(e.style, {
          [t]: n
        }), this.add(() => {
          Object.assign(e.style, {
            [t]: i
          });
        });
      },
      group(e) {
        let t = o();
        return e(t), this.add(() => t.dispose());
      },
      add(e) {
        return s.includes(e) || s.push(e), () => {
          let t = s.indexOf(e);
          if (t >= 0) for (let n of s.splice(t, 1)) n();
        };
      },
      dispose() {
        for (let e of s.splice(0)) e();
      }
    };
  return r;
}
export { o as disposables };